import {PROJECT_WEAVE_PATHS} from './weave/weavePaths';
import {PROJECT_WORKSPACE_PATHS} from './workspace/multiRunWorkspacePaths';
import {RUN_PATHS} from './workspace/singleRunWorkspacePaths';

export const HOME_PATH = '/home';

export const PROJECT_PATHS = [
  ...PROJECT_WORKSPACE_PATHS,
  '/:entityName/:projectName/runs',
  '/:entityName/:projectName/:tab(overview|table|reportlist|sweeps|launch|jobs|automations|artifacts)',
  '/:entityName/:projectName/:tab(artifacts)/:artifactTypeName(new)',
  '/:entityName/:projectName/:tab(artifacts)/:artifactTypeName',
  '/:entityName/:projectName/:tab(artifacts)/:artifactTypeName/:artifactCommitHash(new)',
  '/:entityName/:projectName/:tab(artifacts)/:artifactTypeName/:artifactCollectionName/_view/:artifactCollectionView',
  '/:entityName/:projectName/:tab(artifacts)/:artifactTypeName/:artifactCollectionName/:artifactCommitHash/:artifactTab(files)/:filePath*',
  '/:entityName/:projectName/:tab(artifacts)/:artifactTypeName/:artifactCollectionName/:artifactCommitHash/:artifactTab?',
  '/:entityName/:projectName/:tab(artifacts)/:artifactTypeName/:artifactCollectionName',
  '/:entityName/:projectName/:tab(overview)/:tabName(details|users|providers|weave)',
  '/:entityName/:projectName/:tab(launch)/:launchTab?',
  '/:entityName/:projectName/:tab(jobs)/:jobId',
  '/:entityName/:projectName/:tab(jobs)/:jobId/:jobTab(runs|job_details|version_details)/:jobVersion?',
  ...PROJECT_WEAVE_PATHS,
];

/**
 * for consolidated workspaces, run paths are nested under project page.
 * this is currently feature flagged, but after rollout we'll remove the flag
 * and spread RUN_PATHS into PROJECT_PATHS directly.
 */
export const PROJECT_PATHS_FOR_CONSOLIDATED_WORKSPACES = [
  ...PROJECT_PATHS,
  ...RUN_PATHS,
];

export const REDIRECT_PATH = '/:entityName/:projectName/r/:redirectPath*';

export const NO_ACCESS_PATH = '/no-access';

export const ANALYZE_MY_EXPERIMENTS_PATH = '/analyze_my_experiments';

export const CREATE_TEAM_PATH = '/create-team';

// TODO: move these enums to a more appropriate location
export enum UTM_Source {
  FREE_PLAN = 'free-plan',
  APP_RESOURCE_CENTER = 'app-resource-center',
}

export enum UTM_Content {
  LEFT_NAV = 'left_nav',
}

export enum UTM_Medium {
  APP = 'app',
}

export enum UTM_Term {
  DOCS = 'docs',
  QUICKSTART = 'quickstart',
  FULLY_CONNECTED = 'fully-connected',
}
